var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('router-link',{attrs:{"to":_vm.to,"target":_vm.target}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }